import {
  BreadcrumbSeperator,
  BreadcrumbTitle,
} from "@/components/Breadcrumbs/Breadcrumbs";
import { ProfileButton } from "@/components/ProfileButton/ProfileButton";
import { getCurrentDealEntity } from "@/models/deal";
import { Group } from "@mantine/core";
import { useDocumentTitle } from "@mantine/hooks";
import { useAtomValue } from "jotai";

export const Header = () => {
  const dealEntity = getCurrentDealEntity();
  const { data: deal } = useAtomValue(dealEntity.getObserveEntityRecordAtom());
  const name = deal?.companyName || "( Untitled Company )";
  useDocumentTitle(`ETA IQ - Deal (${name})`);

  return (
    <Group px={"xs"} h={"100%"} w={"100%"} align="center" gap={6}>
      <BreadcrumbTitle>Deal</BreadcrumbTitle>
      <BreadcrumbSeperator />
      <BreadcrumbTitle>{name}</BreadcrumbTitle>

      <Group ml={"auto"} gap={"xs"}>
        <ProfileButton />
      </Group>
    </Group>
  );
};
